import { render } from "./tab-pane.vue?vue&type=template&id=fff748c4"
import script from "./tab-pane.vue?vue&type=script&lang=js"
export * from "./tab-pane.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__